import { Transition } from '@headlessui/react';
import classNames from 'classnames';
import React, { Fragment } from 'react';
import { getDataAutoTestAttributes } from 'shared/lib/data-auto-test';
import { MaterialIcon } from 'shared/ui/MaterialIcon';
import { useResize } from 'shared/ui/MultiSelect/Hooks/useResize';

import style from './Menu.module.scss';

interface ListMenuProps {
  children: React.ReactNode;
  open: boolean;
  className?: string;
  listboxClassName?: string;
  controlsBlock?: React.ReactNode;
  inputBlock?: React.ReactNode;
  withResize?: boolean;
  menuDefaultWidth?: number;
}

export function ListMenu({
  children,
  className,
  controlsBlock,
  listboxClassName,
  inputBlock,
  open,
  withResize,
  menuDefaultWidth,
}: ListMenuProps) {
  const { handleMouseDown, size } = useResize({ defaultWidth: menuDefaultWidth });

  return (
    <Transition
      as={Fragment}
      show={open}
      leave="transition ease-in duration-100 bg-white"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      <div
        className={classNames(style.baseMenu, className, 'outline-none')}
        {...getDataAutoTestAttributes(['multiselect-options']).attributes}
        style={{
          width: `${size.width}px`,
        }}
      >
        {inputBlock}
        <ul className={classNames(style.menuList, listboxClassName, 'outline-none')}>{children}</ul>
        {controlsBlock}
        {withResize && (
          <MaterialIcon
            onMouseDown={handleMouseDown}
            className="pointer-events-auto ml-auto block w-4 cursor-ew-resize text-[16px]"
          >
            drag_indicator
          </MaterialIcon>
        )}
      </div>
    </Transition>
  );
}
